export const MOC_IMPORT_PREVIEW_CARD_OPTIONS = [
    {
        label: 'Название',
        value: 'Название фильма'
    },
    {
        label: 'Описание',
        value: 'Полное описание фильма.....'
    },
    {
        label: 'Год',
        value: '2024'
    },
    {
        label: 'Категории',
        value: 'Боевик, Фантастика'
    },
    {
        label: 'Рейтинг',
        value: '8.5'
    }
]